__turbopack_context__.v({
  "editableInput": "index-module__P0Xu9a__editableInput",
  "placeholderButton": "index-module__P0Xu9a__placeholderButton",
  "placeholderText": "index-module__P0Xu9a__placeholderText",
  "ratioSelectPopup": "index-module__P0Xu9a__ratioSelectPopup",
  "smallUploadButton": "index-module__P0Xu9a__smallUploadButton",
  "textarea": "index-module__P0Xu9a__textarea",
  "tipsMask": "index-module__P0Xu9a__tipsMask",
  "uploadButtonMusic": "index-module__P0Xu9a__uploadButtonMusic",
  "uploadButtonPicture": "index-module__P0Xu9a__uploadButtonPicture",
});
